

























import { Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component
export default class UniqOfferViewer extends mixins(PlanLimitsMixin) {
  @Prop() 
  conditions: any;

  value: string = 'NOT_UNIQUE';
  predicate: string = 'EQUALS';

  mounted() {
    if (this.conditions.uniqOfferViewer) {
      this.value = this.conditions.uniqOfferViewer.values;
      this.predicate = this.conditions.uniqOfferViewer.predicate;
    }

  }

  @Watch('conditions', {
    immediate: true
  })
  onConditionsChanged(value: any, oldValue: any) {
    if(!value.uniqOfferViewer) {
      this.$set(this.conditions, 'uniqOfferViewer', {
        predicate:  'EQUALS',
        values: 'UNIQUE'
      });
    }
  }

  @Watch('value')
  onValueChanged(value: string, oldValue: string) {
    this.$set(this.conditions.uniqOfferViewer, 'values', value);
  }

  @Watch('predicate')
  onPredicateChanged(value: string, oldValue: string) {
    this.$set(this.conditions.uniqOfferViewer, 'predicate', value);
  }
}
